<template>
  <o-form-wrapper v-model="item" :form-state="formState" :schema="schema" :server-errors="_se" :v="$v.item">
    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="job">
      <o-select
        v-model="item.job"
        :form-state="formState"
        :items="optionJobItems"
        :loading="optionJobWorking"
        :server-errors="_se"

        :validators="$v.item"
        add-title="Create New"
        allow-add name="job" sort-field="" store-name="Job"

        text-field=""
        v-bind="schema.fields.job"
        value-field="id"
      >
        <template slot="form" slot-scope="{item, formState, serverErrors}">
          <job-form :form-state="formState" :item="item" :server-errors="serverErrors" in-modal></job-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="start_time">
      <o-text-field
        v-model="item.start_time"

        :form-state="formState"
        :server-errors="_se" :validators="$v.item" name="start_time" v-bind="schema.fields.start_time"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="task_type">
      <o-select
        v-model="item.task_type"
        :form-state="formState"
        :items="optionCodeJobTaskTypeItems"
        :loading="optionCodeJobTaskTypeWorking"
        :server-errors="_se"

        :validators="$v.item"
        name="task_type"
        sort-field="description" text-field="description" v-bind="schema.fields.task_type" value-field="id"

      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="expected_date">
      <o-date-time v-model="item.expected_date"
                   :form-state="formState"
                   :server-errors="_se"
                   :validators="$v.item"
                   name="expected_date" v-bind="schema.fields.expected_date"></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item" name="when">
      <o-date-time v-model="item.when"
                   :form-state="formState"
                   :server-errors="_se"
                   :validators="$v.item"
                   hide-time name="when" v-bind="schema.fields.when"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="truck">
      <o-select
        v-model="item.truck"
        :form-state="formState"
        :items="optionCodeTruckItems"
        :loading="optionCodeTruckWorking"
        :server-errors="_se"

        :validators="$v.item"
        add-title="Create New"
        allow-add name="truck" sort-field="name" store-name="CodeTruck"

        text-field="name"
        v-bind="schema.fields.truck"
        value-field="id"
      >
        <template slot="form" slot-scope="{item, formState, serverErrors}">
          <code-truck-form :form-state="formState" :item="item" :server-errors="serverErrors"
                           in-modal></code-truck-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="trip_number">
      <o-text-field
        v-model="item.trip_number"

        :form-state="formState"
        :server-errors="_se" :validators="$v.item" name="trip_number" v-bind="schema.fields.trip_number"
      ></o-text-field>
    </o-widget-wrapper>

  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin
} from '../../../vue-ocom/mixins'
import {validationMixin} from 'vuelidate'
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import {default as JobForm} from '../../job/components/ItemForm';
import {default as CodeTruckForm} from '../../code_truck/components/ItemForm';


export default {
  mixins: [VuelidateMixin,
    validationMixin,
    CreateFormStateMixin('$v'),
    CreateGroupPermissionMixin('JobTask'),
    CreateCodeTableFetchMixin(['Job', 'CodeTruck', 'CodeJobTaskType',])
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    JobForm,
    CodeTruckForm
  },
  props: {
    item: {
      type: Object, default: () => {
      }
    },
    level: {type: Number, default: 0},
    inModal: {type: Boolean, default: false},
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.JobTask, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    }
  },
  watch: {},
  created() {
  },
}
</script>
